export const HOTEL_CATALOG_NOTE =
  'This page is a South Crete hotel brochure. Rooms are not sold from the catalogue.';

export const HOTEL_AFTER_PAY_COPY =
  'After payment you receive a South Crete booking reference and voucher by email. The stay appears on the hotel desk the same day.';

export const HOTEL_CANCEL_AMEND_COPY =
  'Cancellation and date changes follow the rate rules on your quote. Contact South Crete to amend or cancel — do not write the supplier directly.';
